import { ReactNode } from 'react';

import { useSidebarCollapseContext } from 'app/layout/context/drawer';
import { Box, ButtonIcon, Flex } from 'shared';
import { FlexItem } from 'shared_DEPRECATED/components/Flex';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { Spacers } from 'shared_DEPRECATED/components/Spacer';

export const LayoutPageSidebarWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { isOpen, setIsOpen } = useSidebarCollapseContext();
  const iconName = isOpen
    ? iconNames.doubleArrowLeft
    : iconNames.doubleArrowRight;
  const sidebarBtnAlign = isOpen ? 'flex-end' : 'center';

  return (
    <Box
      data-state={isOpen ? 'open' : 'closed'}
      _open={{
        width: 'var(--sidebar-width)',
      }}
      _closed={{
        width: 'var(--sidebar-width-collapsed)',
      }}
      style={{
        height: '100%',
        borderRight: 'var(--border-secondary)',
        boxSizing: 'border-box',
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      <Spacers height="100%" sizes={['lg']}>
        <Flex
          flexDirection="column"
          justifyContent="flex-start"
          alignItems="stretch"
          height="100%"
        >
          <FlexItem alignSelf={sidebarBtnAlign}>
            <ButtonIcon
              aria-label="toggle sidebar"
              onClick={setIsOpen}
              size="sm"
              variant="ghost"
            >
              <Icon name={iconName} width="24px" height="24px" />
            </ButtonIcon>
          </FlexItem>
          <Spacers sizes={['lg zr zr', 'md zr zr']} />
          <Flex
            height="100%"
            width="100%"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="stretch"
          >
            {children}
          </Flex>
        </Flex>
      </Spacers>
    </Box>
  );
};
